module.exports = __webpack_public_path__ + "img/goods-3.222a43f8.png";